import React from 'react';

import { RxMaintenanceModel } from '../../../../../../Rx/RxMaintenanceModel.csharp';

export const RxMaintenanceAddToCartMessage = ({ header, message }: RxMaintenanceModel) => {
    return (
        <div className="RxMaintenanceAddToCartMessage">
            <div className="RxMaintenanceAddToCartMessage__Icon" />
            <div className="RxMaintenanceAddToCartMessage__Text">
                <div className="RxMaintenanceAddToCartMessage__Header">{header}</div>
                <div className="RxMaintenanceAddToCartMessage__Message">{message}</div>
            </div>
        </div>
    );
};
